import { reactive, ref } from "vue";
import { freezeLastRead } from "./readMarkState";
import { mounted } from "./scrollChatState";
import { fillDeviceList } from "./media/devices";

interface ViewState {
  detailDialog: boolean;
  emojiShow: boolean;
  /**
   * Это именно лента, не инпут
   */
  chatFocused: boolean;
  rightBlockContent: "chat" | "users" | "none";
  lastRightBlockContent: "chat" | "users" | "none";
  showSpeakerInDemo: boolean;
  fullScreenChat: boolean;
  pipMode: boolean;
}

/**
 * Нужно для того чтобы при активной комнате сначала попал на страницу подключения
 * и при явном нажатии подключится происходило подключение к комнате
 */
export const roomStarted = ref(false);

/**
 * Флаг Отображения модалки настроек (имя, камера, микрофон...)
 */
export const settingModalState = ref(false);

export async function openSettingModal() {
  try {
    await fillDeviceList();
  } catch {}
  settingModalState.value = true;
}

export function closeSettingModal() {
  settingModalState.value = false;
}

export const viewState = reactive<ViewState>({
  rightBlockContent: "none",
  lastRightBlockContent: "none",
  emojiShow: false,
  chatFocused: false,
  detailDialog: false,
  showSpeakerInDemo: true,
  fullScreenChat: false,
  pipMode: false,
});

viewState.fullScreenChat = window.innerWidth < 811;

window.addEventListener("resize", () => {
  viewState.fullScreenChat = window.innerWidth < 811;
});

export function toggleUserList() {
  if (viewState.rightBlockContent === "users") {
    SelectTab("none");
  } else {
    SelectTab("users");
  }
}

export function toggleChat() {
  if (viewState.rightBlockContent === "chat") {
    SelectTab("none");
  } else {
    SelectTab("chat");
  }
}

export function SelectTab(tab: ViewState["rightBlockContent"]) {
  const last = viewState.rightBlockContent;
  viewState.lastRightBlockContent = last;
  viewState.rightBlockContent = tab;
  if (last !== tab) {
    if (tab === "chat") {
      freezeLastRead();
    }
    if (last === "chat") {
      mounted.value = false;
    }
  }
}
